import React, { useState } from 'react';
import {
  TableHead,
  TableRow,
  TableCell,
  Dialog,
  IconButton
} from '@material-ui/core';
import { DeleteRounded, AddCircle } from '@material-ui/icons';
import InlineTable from '@/module/common/component/InlineTable';
import TableCellFilted from '@/module/common/componentUI/TableCellFilted';
import AutocompleteModal from '@/module/common/component/AutocompleteModal';
import { ButtonEnhance } from '@/module/common/componentUI/commonStyleComponents';
import { reviewColumn } from '../constants';
import { TableWrapped } from '@/module/company/component/CompanyPaper/styled';
import globalDispatcher from '@/redux/global/actions';
import styled from 'styled-components';

const ReviewsInformation = ({ formValue, setFormValue, disabled }) => {
  const [hiddenRows, setHiddenRows] = useState({});
  const [showModal, setShowModal] = useState(false);

  const onCloseModal = () => {
    setShowModal(false);
  };

  const onAddNewTest = data => {
    const lstReviews = formValue.lstReviews.concat(data);
    setFormValue({ ...formValue, lstReviews });
    setShowModal(false);
  };

  const onDeleteTest = index => {
    let lstReviews = [...formValue.lstReviews];
    lstReviews.splice(index, 1);
    setFormValue({ ...formValue, lstReviews });
  };

  const TableCellFiltedWrapper = ({ ...props }) => (
    <TableCellFilted
      {...{
        hiddenRows,
        setHiddenRows
      }}
      {...props}
    />
  );
  const TableHeader = () => (
    <TableHead>
      <TableRow>
        {reviewColumn.map(item =>
          item.label ? (
            <TableCellFiltedWrapper
              key={item.stateValue}
              label={item.label}
              stateValue={item.stateValue}
            />
          ) : (
            <TableCell key={item.stateValue}></TableCell>
          )
        )}
      </TableRow>
    </TableHead>
  );

  const TableFooter = () =>
    disabled ? null : (
      <StyledButtonEnhance
        background="#EFDFEB"
        color="#AD5E99"
        backgroundHover="#EFDFEB"
        onClick={() => setShowModal(true)}
      >
        <div className="add-group">
          <span>Add new review</span>
          <AddCircle />
        </div>
      </StyledButtonEnhance>
    );

  const renderRow = onDeleteTest => (row, i, onDeleteValue) => (
    <>
      <TableCell>{!hiddenRows.name && row.name}</TableCell>
      <TableCell>{!hiddenRows.stationName && row.stationName}</TableCell>
      <TableCell align="right">
        {!disabled && (
          <IconButton
            className="delete-icon"
            onClick={() => (onDeleteTest ? onDeleteTest(i) : onDeleteValue(i))}
          >
            <DeleteRounded />
          </IconButton>
        )}
      </TableCell>
    </>
  );

  return (
    <TableWrapped>
      <InlineTable
        Header={TableHeader}
        data={formValue.lstReviews}
        Footer={TableFooter}
        noDataHelperText={
          disabled
            ? 'No data'
            : 'Click button "Add new review" to create new one'
        }
        renderRow={renderRow(onDeleteTest)}
      />
      <Dialog maxWidth="lg" open={showModal} onClose={onCloseModal}>
        <AutocompleteModal
          onClose={onCloseModal}
          title="Reviews"
          optionLabel="name"
          textFieldPlaceholder="Select review"
          onSubmit={onAddNewTest}
          Header={TableHeader}
          renderRow={renderRow()}
          getListOptions={(...props) =>
            globalDispatcher.getListServiceByCategory('Reviews', ...props)
          }
          existedOption={formValue.lstReviews}
        />
      </Dialog>
    </TableWrapped>
  );
};

export const StyledButtonEnhance = styled(ButtonEnhance)`
  display: flex;
  justify-content: center;
  max-width: 200px;
  float: right;
  margin-top: 15px;
  height: 35px;
  padding: 8px 16px;
  .add-group {
    display: flex;
    width: fit-content;
    align-items: center;
    margin-top: -2px;
    span {
      margin-right: 8px;
    }
  }
`;

export default ReviewsInformation;
